import React from 'react';
import './style.scss';

interface EmptyStateProps {
    handleCTA: (event: React.MouseEvent) => void;
    iconType: string;
    emptyType: string;
    cta?: string;
    iconCTA?: string;
    labelCTA: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ handleCTA, iconType, emptyType, cta, iconCTA, labelCTA }: EmptyStateProps) => (
    <div className="empty-state">
        <div className="empty-content">
            <i className="material-icons-outlined icon-center icon">
                {iconType}
            </i>
            <h1>{emptyType}</h1>
            <h1>{cta}</h1>

            <button className="btn btn-primary btn-lg m-top--sm text-uppercase" onClick={handleCTA} type="button">
                {iconCTA && (<i className="material-icons-outlined align-middle">{iconCTA}</i>)}
                <span className="align-middle">
                    {labelCTA}
                </span>
            </button>
        </div>
    </div>
);

export default EmptyState;
